import React, { Component } from "react"
import { Table, ProgressBar } from "react-bootstrap"
import { formatPrice, formatGain } from "./format"
import * as firebase from "firebase"

export default class TransactionsTable extends Component {
	constructor(props) {
		super(props)
		this.state = {
			transactions: [],
			isLoaded: false,
		}
	}

	componentDidMount() {
		this.loadData()
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			this.props.uid !== prevProps.uid ||
			this.props.account !== prevProps.account ||
			this.props.symbol !== prevProps.symbol
		) {
			this.loadData()
		}
	}

	loadData() {
		return this.loadTransactions().then((querySnapshots) => {
			const transactions = []
			querySnapshots.forEach((querySnapshot) => {
				querySnapshot.docs.forEach((doc) => {
					if (doc.exists) {
						transactions.push(doc.data())
					}
				})
			})
			transactions.sort((a, b) => b.timestamp - a.timestamp)
			this.setState({ transactions, isLoaded: true })
		})
	}

	loadTransactions() {
		let { uid, accounts, symbol } = this.props
		const db = firebase.firestore()

		const promises = []
		accounts.forEach((account) => {
			// Override for Kraken XBT BULLSHIT
			if (account === "kraken" && symbol === "BTC") {
				symbol = "XBT"
			}

			var transaction = db
				.collection("portfolios")
				.doc(uid)
				.collection("transactions")
				.where("account", "==", account)
				.where("base", "==", symbol)
				.get()
			promises.push(transaction)
		})
		return Promise.all(promises)
	}

	render() {
		const { transactions, isLoaded } = this.state
		const { isPremium = false, quote, averageCost } = this.props
		const transactionHeaders = [
			"Date",
			"Exchange",
			"Action",
			"Quantity",
			"Quote",
			"Price",
			"Fee",
			"Net Amount",
			"Total Quantity",
			"Total Book Value",
			"Gain",
		]
		if (!isLoaded) {
			return <ProgressBar active now={100} />
		}
		if (transactions.length === 0) {
			return <p>No transactions found for this asset.</p>
		}
		return (
			<Table className="transactions-table" responsive>
				<thead>
					<tr>
						{transactionHeaders.map(header => <th key={header}>{header}</th>)}
					</tr>
				</thead>
				<tbody>
					{transactions.map(tx => (
						<TransactionRow
							key={tx.id}
							{...tx}
							assetQuote={quote}
							isPremium={isPremium}
							showGain={averageCost !== null}
						/>
					))}
				</tbody>
			</Table>
		)
	}
}

function TransactionRow({
	account,
	action,
	averageCost,
	fee,
	netAmount,
	price,
	quantity,
	quote,
	totalBookValue,
	totalQuantity,
	timestamp,
	isPremium,
	assetQuote,
	showGain,
}) {
	const ms = timestamp > 2000000000 ? timestamp : timestamp * 1000
	const date = new Date(ms).toLocaleDateString()
	const bookValue = quantity * averageCost
	return (
		<tr>
			<td>{date}</td>
			<td>{account}</td>
			<td className="capitalize">{action}</td>
			<td>{quantity}</td>
			<td>{quote}</td>
			<td>{formatPrice(quote, price, true)}</td>
			<td>{formatPrice(quote, fee, true)}</td>
			<td>{formatPrice(quote, netAmount, true)}</td>
			<td>{totalQuantity}</td>
			<td>{formatPrice(quote, totalBookValue, isPremium)}</td>
			<td>
				{showGain &&
				action === "sell" &&
				quote === assetQuote &&
				!Number.isNaN(bookValue)
					? formatGain(quote, netAmount, bookValue, isPremium)
					: "N/A"}
			</td>
		</tr>
	)
}



// WEBPACK FOOTER //
// ./src/TransactionsTable.js